import React from 'react'

const Fail = () => {
  return (
    <div>
      
    </div>
  )
}

export default Fail
